import Pikaday from "pikaday";
import moment from "moment";

var picker = new Pikaday({
    field: document.querySelector("input[name^='et_pb_contact_datepicker']"),
    format: "Do MMM YYYY",
});
